import { useEffect, useRef, useState } from "react";
import { AdvancedImage } from "@cloudinary/react";
import { fill } from "@cloudinary/url-gen/actions/resize";
import localeText from "../../../../locale";
import { cloudinaryInstance } from "../../../../utilities/Cloudinary/cloudinaryInstance";
import { MAX_IMAGE_MB } from "../../utils/catalogUtils";
import FormField from "./FormField";

// Uma imagem: mostra a atual (Cloudinary) ou a nova escolhida, com validação de tamanho
const ImagePicker = ({ label, currentImageId, file, onChange, error, onError, required }) => {
  const inputRef = useRef(null);
  const [preview, setPreview] = useState(null);

  useEffect(() => {
    if (!file) {
      setPreview(null);
      return undefined;
    }
    const url = URL.createObjectURL(file);
    setPreview(url);
    return () => URL.revokeObjectURL(url);
  }, [file]);

  const handleFile = (selected) => {
    if (!selected) return;
    if (!selected.type.startsWith("image/")) {
      onError(localeText("adminFormImageInvalid"));
      return;
    }
    if (selected.size / 1024 / 1024 > MAX_IMAGE_MB) {
      onError(localeText("fileSizeTooBig"));
      return;
    }
    onChange(selected);
  };

  const hasImage = !!(preview || currentImageId);

  return (
    <FormField
      label={label}
      error={error}
      required={required}
      hint={localeText("adminFormImageHint").replace("{mb}", MAX_IMAGE_MB)}
    >
      <div
        className="admin-image-picker"
        onDragOver={(e) => e.preventDefault()}
        onDrop={(e) => {
          e.preventDefault();
          handleFile(e.dataTransfer.files?.[0]);
        }}
      >
        <div className="admin-image-picker__preview">
          {preview ? (
            <img src={preview} alt="" />
          ) : currentImageId ? (
            <AdvancedImage
              cldImg={cloudinaryInstance
                .image(currentImageId)
                .resize(fill().width(192).height(192))
                .format("webp")}
              alt=""
            />
          ) : (
            <i className="pi pi-image" aria-hidden="true" />
          )}
        </div>
        <div className="admin-image-picker__actions">
          <button type="button" className="admin-btn" onClick={() => inputRef.current?.click()}>
            <i className="pi pi-upload" aria-hidden="true" />
            {localeText(hasImage ? "adminFormImageReplace" : "adminFormImageChoose")}
          </button>
          {file && (
            <button type="button" className="admin-link-btn" onClick={() => onChange(null)}>
              {localeText(currentImageId ? "adminFormImageKeepCurrent" : "adminFormImageRemove")}
            </button>
          )}
          <span className="admin-muted">{localeText("adminFormImageDrop")}</span>
        </div>
        <input
          ref={inputRef}
          type="file"
          accept="image/*"
          hidden
          onChange={(e) => {
            handleFile(e.target.files?.[0]);
            e.target.value = "";
          }}
        />
      </div>
    </FormField>
  );
};

export default ImagePicker;
